import { Route as UniversalRoute } from 'next-universal-route';

import type { Route } from './types';

const landing: Route = { route: new UniversalRoute('/', 'landing') };
const mate: Route = { route: new UniversalRoute('/mate', 'mate') };
const mateVerify: Route = {
  route: new UniversalRoute('/mate-verify', 'mate-verify'),
};
const checkout: Route = {
  route: new UniversalRoute('/checkout', 'checkout'),
  secured: true,
};
const checkoutConfirmation: Route = {
  route: new UniversalRoute('/checkout-confirmation', 'checkout-confirmation'),
  secured: true,
};
const modifySubscription: Route = {
  route: new UniversalRoute('/modify-subscription', 'modify-subscription'),
  secured: true,
};
export const Routes = {
  mate,
  mateVerify,
  landing,
  checkout,
  checkoutConfirmation,
  modifySubscription,
} as const;
